import { useMutation, useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'

import { post } from '../apiClient'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

export interface RemoveRightOfAccessRequest {
  rightOfAccessId: number
}

export const useAPIRemoveRightOfAccess = (contractId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (request: RemoveRightOfAccessRequest): Promise<void> => {
      await post(
        `/contracts/${contractId}/rights-of-access/${request.rightOfAccessId}/terminate`,
        {},
        z.void()
      )
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [`${API_ENDPOINTS.CONTRACTS}/${contractId}/rights-of-access`],
      })
      await queryClient.invalidateQueries({
        queryKey: [`${API_ENDPOINTS.CONTRACTS}/${contractId}/shared-areas`],
      })
    },
  })
}
